
define('text!views/pages/cash/CannotWithdrawViewModel.html',[],function () { return '<div class="pad center">\n    <div class="pad">{{{ message }}}</div>\n\n    <div class="pad center">\n        <div>{{{ summary }}}</div>\n\n        {{#if: wagerAmount }}\n            <div class="gutter-small">{{{ wagerLabel }}}</div>\n        {{/if}}\n    </div>\n</div>\n';});

